import { FunctionComponent } from "react";
import styles from "./SignInSubTitle.module.css";
import { useLocation } from "react-router-dom";
import {roles} from "../../../helper";

interface SignInSubTitleProps {
  role: string;
}


const SignInSubTitle: FunctionComponent<SignInSubTitleProps> = ({ role }) => {
  const location = useLocation();
  const topTitle = {
    title: "",
    subTitle: "",
  };

  // titles changed based on the pathname
  switch (location.pathname) {
    case "/login":
      topTitle.title = "Welcome to QuickAsyst Portal";
      topTitle.subTitle = role !== roles.SUPER_USER ? "Login to access admin portal" : "Login to access your dashboard";
      break;
    case "/forgot-password":
      topTitle.title = "Forgot Password?";
      topTitle.subTitle = "Enter your email to reset your password";
      break;
    case "/reset-password":
        topTitle.title = "Reset Password?";
        topTitle.subTitle = "Enter your new password";
        break;
    default: 
    topTitle.title  = '';
    topTitle.subTitle = '';
    break;
  }
  return (
    <div className={styles.welcomeText}>
      <b className={styles.welcomeToQuickAsyst}>{topTitle.title}</b>
      <div className={styles.loginToAccess}>{topTitle.subTitle}</div>
    </div>
  );
};

export default SignInSubTitle;
